import styled from 'styled-components';
import { rem } from 'polished';
import Icon from '../Icon';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

export const StyledButtonArrowRight = styled.button`
  align-items: center;
  background-color: transparent;
  border: 0;
  display: flex;
  height: ${rem('40px')};
  justify-content: center;
  outline: none;
  position: absolute;
  right: 0;
  top: calc(50% - 20px);
  transition: all 0.3s ease-in 0s;
  width: ${rem('40px')};
  z-index: 2;
  ${mediaqueries.greaterThan('desktop')`
    background-color: ${props => props.theme.colors.GrayLight}B0;
  `};
`;

export const StyledButtonArrowLeft = StyledButtonArrowRight.extend`
  left: 0;
`;

export const StyledIcon = styled(Icon)`
  height: ${rem('16px')};
  width: ${rem('8px')};
`;
